import { useEffect, useState } from "react";
import P2P from "../components/p2p";
import Feed from "../pages/Feed";
import MyPost from "../pages/MyPost";
import Asset from "../pages/Asset";
import Send from "../pages/Send";
import UsdtSend from "../pages/UsdtSend";
import SendUsdtInternal from "../pages/SendUsdtInternal";
import Transaction from "../pages/Transaction";
import Connect from "../pages/connect";
import ChatList from "../components/ChatList";
import Notifications from "../pages/Notifications";
import { Settings } from "../pages/Settings";
import { Status } from "../pages/Status";
import About from "../pages/About";
import Help from "../pages/Help";
import Moment from "../pages/Moment";
import MyMediaPost from "../pages/MyMediaPost";
import UserInfoOverlay from "../components/UserInfoOverlay";


export default function MobileAppLayout({
  mobileView,
  activeTab,
  setActiveTab,
  TABS,
  isPostPage,

  // shared
  socket,
  myChatId,
  myUserName,
  currentUser,
  users,
  groups,
   groupMembers,
  typingUsers,
  groupTyping,
  searchQuery,
  setSearchQuery,
  selectedItem,
  setSelectedItem,
  menuOpen,
  setMenuOpen,
  createGroupMode,
  setCreateGroupMode,
  menuRef,
  openConnect,
  handleLogout,
  setAvatarZoom,
  notificationCounts,
  commentsByPost,
  feedActionSocket,
  onViewPost,
  cachedChatList,

  // feed
  globalLivePosts,
  followingPosts,
  commentedPosts,
  myPosts,
  viewedPostsUser,
  viewedAuthorPosts,
  onExitAuthorPosts,
  feedSocket,
  uploadFeedMedia,
  handleOpenPost,
  myDisplayName,
 
  // 🎬 Moment (Media)
globalMediaLivePosts,
followingMediaPosts,
commentedMediaPosts,
myMediaPosts,
mediaNotifications,
mediaCommentsByPost,
viewedMediaPostsUser,
viewedAuthorMediaPosts,
onExitAuthorMediaPosts,
mediaSocket,
fetchMediaPosts,
fetchGlobalMediaPosts,

  // p2p
   p2pEvent,
  p2pOffers,
  setP2pOffers,
  p2pOrders,
    setMyAds,
    myUsdtAd,
     myAds,
setMyUsdtAd,
  orderTimers,
  wallet,
  activeP2POrder,
  setActiveP2POrder,
  activeP2PPage,
  setActiveP2PPage,
  setMessages,
    openSellerChat,
  getUserKey,
  uuid,
 onCreateUsdtAd,
onGetMyUsdtAd,
onUpdateUsdtAd,
onCancelUsdtAd,
onConfirmPayment,
onCreateUsdtOrder,
refreshOffers,
  openDmChat,
  sellerPaymentDetails,
sellerCurrency,
loadSellerPaymentDetails,
  clearP2pEvent,
   sendMessage,
   setPendingMedia,
  
  // assets
  assetView,
  setAssetView,
  sendAsset,
  setSendAsset,
  usdt,
  usdtAddress,
   ghsxWallet,
  usdtBalance,
  uswdSocket,
  usdtSocket,
   ghsxSocket,
    onUswdPurchaseSuccess,
     buyDataPage,
    usdtHistory,
      uswdHistory,
      ghsxHistory,
     usdtSendSuccessRef,
    usdtSendErrorRef,

    
  // Status
statusSocket,
statusNotifications,
setStatusNotifications,
myStatusIds,
hasUnreadStatus,
selectedReply,
setSelectedReply,
notificationsBadgeCount,

  // USWD — fetched once in GroupChat
  uswdWallet,
  uswdPricing,
ghsxPricing,
  uswdLoading,
  uswdError,
  isApprovedSeller,
  onRefreshUswdBalance,

  // connect
  nearbyUsers,
 searchUsers,
  // home tab preference
  setDefaultTab,

  // settings
  uploadToR2,
  settingsSocket,
  theme,
  toggleTheme,
  rentRefundRequest,
setRentRefundRequest,

  // infinite scroll
  onLoadMoreFeed,
  onLoadMoreGlobal,
  onLoadMoreInteractions,
  onLoadMoreMyPosts,
  feedHasMore,
  feedLoading,
  globalHasMore,
  globalLoading,
  interactionHasMore,
  interactionLoading,
   interactionsBadgeCount,
  myPostsHasMore,
  myPostsLoading,
  
}) {

  const [transactionAsset, setTransactionAsset] = useState("uswd");

  // Author whose profile is open in <UserInfoOverlay /> (set from the author
  // avatar in Moment). Must stay above the `if (!mobileView) return null`
  // early return below so hook order never changes.
  const [profileUser, setProfileUser] = useState(null);

   const handleOpenProfile = (user) => {
    if (!user) return;
    setProfileUser(user);
  };

  // Opens the UserInfoOverlay for the viewer's own profile (top-right avatar in Moment).
  // avatarUrl is declared later (line 283) but only read when this runs on click, so that's fine.
  const handleOpenMyProfile = () => {
    setProfileUser({
      chatId: myChatId,
      username: myUserName,
      displayName: myDisplayName,
      profileImageUrl: avatarUrl,
    });
  };

   useEffect(() => {
    setProfileUser(null);
  }, [activeTab]);

  // "Feed family" tabs share one persistently-mounted container (Feed, My Posts,
  // Interactions, Notifications) so switching between them doesn't remount/lose
  // scroll position. That container must ONLY take up layout space while one of
  // these tabs is active — otherwise it keeps sitting in the flex row (even with
  // just visibility:hidden on its children) and breaks the layout of Chats,
  // Settings, P2P, Connect, Assets, etc.
  const isFeedFamilyTab =
    activeTab === TABS.FEED ||
    activeTab === TABS.MY_POSTS ||
    activeTab === TABS.INTERACTIONS ||
    activeTab === TABS.NOTIFICATIONS;

if (!mobileView) return null;

const handleViewTransactions = (assetType) => {
  setTransactionAsset(assetType);
  setAssetView("transactions");
};

const handleOpenDm = (
  sellerChatId,
  sellerUsername
) => {

  if (
    !sellerChatId ||
    !socket
  ) {
    return;
  }


  const found =
    users.find(
      (u) =>
        String(u.chatId) ===
        String(sellerChatId)
    );

  const item =
    found
      ? {
          ...found,
          type: "user",
        }
      : {
          type: "user",
          chatId:
            sellerChatId,
          username:
            sellerUsername ||
            "@User",
          online: false,
          unreadCount: 0,
        };

  // Match useGroupChatState.openDmChat()
  setActiveTab(
    TABS.CHATS
  );

  setSelectedItem(
    null
  );

  setTimeout(() => {


    setSelectedItem(
      item
    );

    if (socket.connected) {
      socket.emit(
        "select-chat",
        {
          recipientChatId:
            sellerChatId,
        }
      );
    }

  }, 0);

};
  const avatarUrl =
    currentUser?.profileImageUrl ||
    currentUser?.avatarUrl ||
    null;

  /* ---------------------------------------------------------
     PROFILE OVERLAY HELPERS (plain functions — no hooks)
  --------------------------------------------------------- */

  // Groups to list in the overlay's Groups tab:
  //   - own profile  → groups I'm a member of
  //   - someone else → groups BOTH of us are members of
  const getMutualGroups = (user) => {
    if (!user) return [];

    const isMe = String(user.chatId) === String(myChatId);

    return (groups || []).filter((g) => {
      const members = groupMembers?.[g.groupId] || g.members || [];
      if (!Array.isArray(members)) return false;

      const hasMember = (id) =>
        members.some((m) => String(m?.chatId ?? m) === String(id));

      return isMe
        ? hasMember(myChatId)
        : hasMember(myChatId) && hasMember(user.chatId);
    });
  };

  // This author's media posts, for the overlay's Media tab. GroupChat does
  // not currently supply viewedAuthorMediaPosts, so when it is missing the
  // posts are collected from the lists this layout already has, de-duplicated
  // by postId and filtered to the author.
  const getMediaPostsForUser = (user) => {
    if (!user) return [];

    const uid = String(user.chatId);

    if (
      viewedMediaPostsUser &&
      String(viewedMediaPostsUser.chatId) === uid &&
      viewedAuthorMediaPosts?.length
    ) {
      return viewedAuthorMediaPosts;
    }

    const byId = new Map();

    [
      myMediaPosts,
      followingMediaPosts,
      globalMediaLivePosts,
      commentedMediaPosts,
    ].forEach((list) => {
      (list || []).forEach((p) => {
        if (!p?.postId) return;
        if (String(p.author?.chatId ?? p.chatId) !== uid) return;
        byId.set(p.postId, p);
      });
    });

    return [...byId.values()];
  };

  return (
    <>
      {/* ================= MOBILE — P2P ================= */}
      {activeTab === TABS.P2P && (
        <div className="flex-1 h-full pb-16">
   <P2P
  socket={socket}
  myChatId={myChatId}
    users={users}  
    p2pEvent={p2pEvent}
  offers={p2pOffers}
  setOffers={setP2pOffers}
   myDisplayName={myDisplayName}
    ghsxWallet={ghsxWallet}
  p2pOrders={p2pOrders}
    onConfirmPayment={onConfirmPayment}
  orderTimers={orderTimers}
  wallet={wallet}
   setMyAds={setMyAds}   // ← ADD THIS
   myUsdtAd={myUsdtAd}
   myAds={myAds}
setMyUsdtAd={setMyUsdtAd}
  setP2pOffers={setP2pOffers}
  activeP2POrder={activeP2POrder}
  setActiveP2POrder={setActiveP2POrder}
  activeP2PPage={activeP2PPage}
  setActiveP2PPage={setActiveP2PPage}
   clearP2pEvent={clearP2pEvent}
   sendMessage={sendMessage}
   setPendingMedia={setPendingMedia}
onRefreshOffers={
   refreshOffers
}
 sellerPaymentDetails={
     sellerPaymentDetails
  }

  sellerCurrency={
     sellerCurrency
  }

  loadSellerPaymentDetails={
     loadSellerPaymentDetails
  }

  setMessages={setMessages}
  getUserKey={getUserKey}
  uuid={uuid}
   
onCreateAd={(payload) => {

        if (payload.asset === "USDT") {
            onCreateUsdtAd({
                ...payload,
                userId: currentUser?._id,
            });
            return;
        }

        socket.emit("p2p:create-ad", {
            ...payload,
            userId: currentUser?._id,
        });
    }}
onUpdateAd={(payload) => {
        socket.emit("p2p:update-ad", payload);
    }}
onGetMyUsdtAd={onGetMyUsdtAd}
onUpdateUsdtAd={onUpdateUsdtAd}

onCancelUsdtAd={onCancelUsdtAd}

    onCreateOrder={(payload) => {
        if (payload.asset === "USDT") {
            onCreateUsdtOrder(payload);
            return;
        }

        socket.emit("p2p:create-order", payload);
    }}

    onOpenDm={handleOpenDm}
  onBack={() => setActiveTab(TABS.CHATS)}
  mobileView={mobileView}
/>
        </div>
      )}

      {/* ================= MOBILE — FEED SCREENS ================= */}
<div
  className={isFeedFamilyTab ? "relative flex-1 h-full pb-16" : "hidden"}
>
  {/* Feed */}
  <div
  className="absolute inset-0"
  style={{
    visibility:
      activeTab === TABS.FEED && !isPostPage ? "visible" : "hidden",
    pointerEvents:
      activeTab === TABS.FEED && !isPostPage ? "auto" : "none",
  }}
>
  <Feed
    TABS={TABS}
    myChatId={myChatId}
    currentUser={currentUser}
    groups={groups}
    groupMembers={groupMembers}
    socket={socket}
    uploadImage={uploadToR2}
    myUserName={myUserName}
    myDisplayName={myDisplayName}
    users={users}
    uswdWallet={uswdWallet}
    feedPosts={globalLivePosts}
    followingPosts={followingPosts}
    onCreatePost={feedSocket.createPost}
    onSupportPost={feedSocket.supportPost}
    onSupportComment={feedSocket.supportComment}
    onLikePost={feedSocket.likePost}
    onAddComment={feedSocket.addComment}
    onRepost={feedSocket.repostPost}
    onUploadMedia={uploadFeedMedia}
    onDeletePost={feedActionSocket.deletePost}
    onEditPost={feedActionSocket.editPost}
    onReportPost={feedActionSocket.reportPost}
    activeTab={activeTab}
    setActiveTab={setActiveTab}
    avatarUrl={avatarUrl}
    onViewPost={onViewPost}
    feedSocket={feedSocket}
    setDefaultTab={setDefaultTab}
    onLogout={handleLogout}
    onLoadMoreFeed={onLoadMoreFeed}
    onLoadMoreGlobal={onLoadMoreGlobal}
    feedHasMore={feedHasMore}
    feedLoading={feedLoading}
    globalHasMore={globalHasMore}
    globalLoading={globalLoading}
    interactionsBadgeCount={interactionsBadgeCount}
    notificationsBadgeCount={notificationsBadgeCount}
  />
</div>


  {/* My Posts */}
  <div
    className="absolute inset-0"
    style={{
      visibility:
        activeTab === TABS.MY_POSTS ? "visible" : "hidden",
      pointerEvents:
        activeTab === TABS.MY_POSTS ? "auto" : "none",
    }}
  >
          <MyPost
            myChatId={myChatId}
            users={users}
            myPosts={viewedPostsUser ? viewedAuthorPosts : myPosts}
            viewedUser={viewedPostsUser}
             myDisplayName={myDisplayName}
             uswdWallet={uswdWallet}
            avatarUrl={avatarUrl}
            onLikePost={feedSocket.likePost}
            onRepost={feedSocket.repostPost}
            onSupportPost={feedSocket.supportPost}
  onSupportComment={feedSocket.supportComment}
            onBack={() => { onExitAuthorPosts?.(); setActiveTab(TABS.FEED); }}
            onDeletePost={feedActionSocket.deletePost}
            onEditPost={feedActionSocket.editPost}
            feedSocket={feedSocket}
            onReportPost={feedActionSocket?.reportPost}
            onLoadMore={viewedPostsUser ? undefined : onLoadMoreMyPosts}
            hasMore={viewedPostsUser ? false : myPostsHasMore}
            loading={viewedPostsUser ? false : myPostsLoading}
          />
  </div>

  {/* Interactions */}
  <div
    className="absolute inset-0"
    style={{
      visibility:
        activeTab === TABS.INTERACTIONS ? "visible" : "hidden",
      pointerEvents:
        activeTab === TABS.INTERACTIONS ? "auto" : "none",
    }}
  >
          <Feed
            TABS={TABS}
            mode="commented"
            myChatId={myChatId}
            currentUser={currentUser}
  groups={groups}
  groupMembers={groupMembers}
  socket={socket}
  uploadImage={uploadToR2}
            onViewPost={handleOpenPost}
            uswdWallet={uswdWallet}
            myUserName={myUserName}
             myDisplayName={myDisplayName}
            users={users}
            feedPosts={commentedPosts}
            followingPosts={[]}
            onCreatePost={feedSocket.createPost}
            onSupportPost={feedSocket.supportPost}
  onSupportComment={feedSocket.supportComment}
            onLikePost={feedSocket.likePost}
            onAddComment={feedSocket.addComment}
            onRepost={feedSocket.repostPost}
            onUploadMedia={uploadFeedMedia}
            onDeletePost={feedActionSocket.deletePost}
            onEditPost={feedActionSocket.editPost}
            onReportPost={feedActionSocket.reportPost}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            avatarUrl={avatarUrl}
            feedSocket={feedSocket}
            onLoadMoreInteractions={onLoadMoreInteractions}
            interactionHasMore={interactionHasMore}
            interactionLoading={interactionLoading}
                interactionsBadgeCount={interactionsBadgeCount}
                 notificationsBadgeCount={notificationsBadgeCount}
          />
  </div>

  {/* Notifications */}
  <div
    className="absolute inset-0"
    style={{
      visibility:
        activeTab === TABS.NOTIFICATIONS ? "visible" : "hidden",
      pointerEvents:
        activeTab === TABS.NOTIFICATIONS ? "auto" : "none",
    }}
  >
    <Notifications
      notificationCounts={notificationCounts}
      posts={[...globalLivePosts, ...followingPosts]}
      users={users}
      myDisplayName={myDisplayName}
      myChatId={myChatId}
      currentUser={currentUser}
      groups={groups}
      groupMembers={groupMembers}
      socket={socket}
      uploadImage={uploadToR2}
      commentsByPost={commentsByPost}
      onBack={() => {
        setSelectedItem(null);
        setActiveTab(TABS.FEED);
      }}

      // Navigation
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      TABS={TABS}
    />
  </div>
</div>

{/* ================= MOBILE — MOMENT ================= */}
<div
  className="absolute inset-0"
  style={{
    visibility:
      activeTab === TABS.MOMENT ? "visible" : "hidden",
    pointerEvents:
      activeTab === TABS.MOMENT ? "auto" : "none",
  }}
>
  <Moment
    TABS={TABS}
    mode="main"

    myChatId={myChatId}
    currentUser={currentUser}
    groups={groups}
    groupMembers={groupMembers}
    myUserName={myUserName}
    myDisplayName={myDisplayName}
    users={users}
    uswdWallet={uswdWallet}

    fetchMediaPosts={fetchMediaPosts}
    fetchGlobalMediaPosts={fetchGlobalMediaPosts}

    mediaPosts={globalMediaLivePosts}
    followingMediaPosts={followingMediaPosts}
    commentedMediaPosts={commentedMediaPosts}
    myMediaPosts={myMediaPosts}
    mediaNotifications={mediaNotifications}
 mediaCommentsByPost={mediaCommentsByPost}
    viewedMediaPostsUser={viewedMediaPostsUser}
    viewedAuthorMediaPosts={viewedAuthorMediaPosts}
    onExitAuthorMediaPosts={onExitAuthorMediaPosts}

    onUploadMedia={uploadFeedMedia}

    onCreateMediaPost={mediaSocket.mediaCreatePost}
    onLikeMediaPost={mediaSocket.mediaLikePost}
    onAddMediaComment={mediaSocket.mediaAddComment}
      onTrackMediaView={mediaSocket.mediaTrackView}
    onTrackMediaCommentView={mediaSocket.mediaTrackView}
    onLikeMediaComment={mediaSocket.mediaLikeComment}
    onClearMediaNotifications={mediaSocket.mediaClearNotifications}
    onSupportMediaPost={mediaSocket.mediaSupportPost}

    mediaSocket={mediaSocket}

    activeTab={activeTab}
 suspended={!!profileUser}
    onAvatarClick={handleOpenProfile}
    onMyAvatarClick={handleOpenMyProfile}
    setActiveTab={setActiveTab}
    avatarUrl={avatarUrl}
    setDefaultTab={setDefaultTab}
    onLogout={handleLogout}
  />
</div>

{/* ================= MOBILE — MY MEDIA POSTS ================= */}
<div
  className="absolute inset-0"
  style={{
    visibility: activeTab === TABS.MY_MEDIA_POSTS ? "visible" : "hidden",
    pointerEvents: activeTab === TABS.MY_MEDIA_POSTS ? "auto" : "none",
  }}
>
  <MyMediaPost
    myChatId={myChatId}
    myUserName={myUserName}
    myDisplayName={myDisplayName}
    currentUser={currentUser}
    avatarUrl={avatarUrl}
    users={users}
    myMediaPosts={viewedMediaPostsUser ? viewedAuthorMediaPosts : myMediaPosts}
    viewedUser={viewedMediaPostsUser}
    mediaCommentsByPost={mediaCommentsByPost}
    onLikeMediaPost={mediaSocket.mediaLikePost}
    onAddMediaComment={mediaSocket.mediaAddComment}
    onLikeMediaComment={mediaSocket.mediaLikeComment}
    onSupportMediaPost={mediaSocket.mediaSupportPost}
       onTrackMediaView={mediaSocket.mediaTrackView}
    onTrackMediaCommentView={mediaSocket.mediaTrackView}
    onBack={() => {
      onExitAuthorMediaPosts?.();
      setActiveTab(TABS.MOMENT);
    }}
  />
</div>

      {/* ================= MOBILE — ASSETS ================= */}
      {activeTab === TABS.ASSETS && (
        <div className="flex-1 h-full min-h-0 overflow-hidden pb-16 flex flex-col">
          {assetView === "list" && (
                    <Asset
              wallet={wallet}
               myChatId={myChatId}
                socket={socket} 
              usdt={{
                address:   usdtAddress,
                balance:   usdtBalance?.balance   ?? 0,
                committed: usdtBalance?.committed ?? 0,
                available: usdtBalance?.available ?? 0,
              }}
                 usdtSocket={usdtSocket}
                  ghsxWallet={ghsxWallet}
                  ghsxSocket={ghsxSocket}
              currentUser={currentUser}
              onSend={(asset) => { setSendAsset(asset); setAssetView("send"); }}
              onTransactions={handleViewTransactions}
              onBack={() => setActiveTab(TABS.CHATS)}
              mobileView={mobileView}
              uswdWallet={uswdWallet}
              uswdPricing={uswdPricing}
ghsxPricing={ghsxPricing}
              uswdLoading={uswdLoading}
              uswdError={uswdError}
              isApprovedSeller={isApprovedSeller}
              onRefreshUswdBalance={onRefreshUswdBalance}
                   onUswdPurchaseSuccess={onUswdPurchaseSuccess}
               uswdSocket={uswdSocket} 
                usdtSendSuccessRef={usdtSendSuccessRef}
    usdtSendErrorRef={usdtSendErrorRef}
            />
          )}
          {assetView === "send" && sendAsset === "btc" && (
      <Send wallet={{ ...wallet, chatId: myChatId }} onBack={() => setAssetView("list")} />
          )}
          {assetView === "send" && sendAsset === "usdt" && (
            <UsdtSend wallet={{ chatId: myChatId }} usdtSocket={usdt} usdtBalance={usdtBalance} socket={socket} onBack={() => setAssetView("list")} />
          )}
        {assetView === "send" && sendAsset === "usdt_internal" && (
   <SendUsdtInternal
  wallet={{ chatId: myChatId }}
  usdtSocket={usdtSocket}
  usdtBalance={usdtBalance}
  available={usdtBalance?.available ?? 0}
  onBack={() => setAssetView("list")}
  mobileView={mobileView}
  onSendSuccess={usdtSendSuccessRef}
  onSendError={usdtSendErrorRef}
/>
)}
{assetView === "transactions" && (
 <Transaction
  asset={transactionAsset}
  uswdHistory={uswdHistory}
  usdtHistory={usdtHistory}
   ghsxHistory={ghsxHistory}
  onBack={() => setAssetView("list")}
  mobileView={mobileView}
  socket={socket}
/>
)}
         
        </div>
      )}
{activeTab === TABS.TRANSACTIONS && (
  <div className="flex-1 h-full min-h-0 overflow-hidden flex flex-col">
    <Transaction
      asset={transactionAsset}
      uswdHistory={uswdHistory}
      usdtHistory={usdtHistory}
      ghsxHistory={ghsxHistory}
      onBack={() => setActiveTab(TABS.ASSETS)}
      mobileView={mobileView}
      socket={socket}
    />
  </div>
)}
 
          {/* ================= MOBILE — CONNECT ================= */}
      {activeTab === TABS.CONNECT && (
        <div className="flex-1 h-full pb-16">
          <Connect
            users={nearbyUsers}
            searchUsers={searchUsers}
            myChatId={myChatId}
            onFollow={(targetChatId) => feedSocket.followUser({ targetChatId })}
            onUnfollow={(targetChatId) => feedSocket.unfollowUser({ targetChatId })}
            onBack={() => setActiveTab(TABS.CHATS)}
            uploadImage={uploadToR2}
            socket={socket}
            groups={groups}
            groupMembers={groupMembers}
            onOpenGroup={(g) => {
              setActiveTab(TABS.CHATS);
              setSelectedItem({
                type: "group",
                groupId: g.groupId,
                name: g.name,
                groupImageUrl: g.groupImageUrl,
              });
            }}
          />
        </div>
      )}

               {/* ================= MOBILE — BUY DATA ================= */}
      {activeTab === TABS.BUY_DATA && (
        <div className="flex-1 h-full min-h-0 overflow-hidden pb-16">
          {buyDataPage}
        </div>
      )}

          {/* ================= MOBILE — SETTINGS ================= */}
    {activeTab === TABS.SETTINGS && (
        <div className="flex-1 h-full pb-16 overflow-y-auto">
        <Settings
  currentUser={currentUser}
  myChatId={myChatId}
  myDisplayName={myDisplayName}
  uploadImage={uploadToR2}
  settingsSocket={settingsSocket}
  socket={socket}
  rentRefundRequest={rentRefundRequest}
  setRentRefundRequest={setRentRefundRequest}
  onBack={() => setActiveTab(TABS.CHATS)}
  theme={theme}
  onToggleTheme={toggleTheme}
/>
        </div>
      )}
      {/* ================= MOBILE — ABOUT ================= */}
      {activeTab === TABS.ABOUT && (
        <div className="flex-1 h-full pb-16 overflow-y-auto">
          <About
            onBack={() => setActiveTab(TABS.CHATS)}
          />
        </div>
      )}

      {/* ================= MOBILE — HELP ================= */}
      {activeTab === TABS.HELP && (
        <div className="flex-1 h-full pb-16 overflow-y-auto">
          <Help
            onBack={() => setActiveTab(TABS.CHATS)}
          />
        </div>
      )}

      {/* ================= MOBILE — STATUS ================= */}
      {activeTab === TABS.STATUS && (
        <div className="flex-1 h-full">

<Status
  socket={socket}
  myChatId={myChatId}
  currentUser={currentUser}
  users={users}
  mobileView={mobileView}
  onBack={() => setActiveTab(TABS.CHATS)}

  statusSocket={statusSocket}
  statusNotifications={statusNotifications}
  setStatusNotifications={setStatusNotifications}
  myStatusIds={myStatusIds}
  hasUnreadStatus={hasUnreadStatus}

  /* Existing */
  sendMessage={sendMessage}
  selectedReply={selectedReply}
  setSelectedReply={setSelectedReply}

  /* DM reply support */
  setMessages={setMessages}
  setUsers={users ? undefined : undefined}
  getUserKey={getUserKey}
  uuid={uuid}
  showToast={undefined}
  setSelectedItem={setSelectedItem}

  /* Open the DM after replying */
  openDmChat={handleOpenDm}
/>

        </div>
      )}
{/* ================= MOBILE — CHAT LIST ================= */}
{activeTab === TABS.CHATS && !selectedItem && (
  <div className="flex-1 h-full w-full pb-16">
    <ChatList
      users={users}
      groups={groups}
      typingUsers={typingUsers}
      groupTyping={groupTyping}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      selectedItem={selectedItem}
      setSelectedItem={setSelectedItem}
      menuOpen={menuOpen}
      setMenuOpen={setMenuOpen}
      mobileView={mobileView}
      createGroupMode={createGroupMode}
      setCreateGroupMode={setCreateGroupMode}
      menuRef={menuRef}
      activeTab={activeTab}
      myDisplayName={myDisplayName}
      setActiveTab={setActiveTab}
      onOpenConnect={openConnect}
      onLogout={handleLogout}
      isLoggedIn={!!currentUser}
      onOpenAvatar={setAvatarZoom}
      setDefaultTab={setDefaultTab}
      cachedChatList={cachedChatList}
      p2pOrders={p2pOrders}
      orderTimers={orderTimers}
      myChatId={myChatId}
      hasUnreadStatus={hasUnreadStatus}
      notificationsBadgeCount={notificationsBadgeCount}
      interactionsBadgeCount={interactionsBadgeCount}
      statusSocket={statusSocket}
    />
  </div>
)}

      {/* ================= MOBILE — USER INFO OVERLAY =================
          Opened from the author avatar in Moment. Portals into <body>, so
          its position in this tree doesn't affect stacking. Opens on the
          Media tab since that's where the avatar tap came from. */}
      <UserInfoOverlay
        open={!!profileUser}
        onClose={() => setProfileUser(null)}
        user={profileUser}
        initialTab="media"
               myChatId={myChatId}
        isFollowing={
          !!users.find((u) => String(u.chatId) === String(profileUser?.chatId))
            ?.isFollowing
        }
        onFollow={() => feedSocket.followUser({ targetChatId: profileUser?.chatId })}
        onUnfollow={() => feedSocket.unfollowUser({ targetChatId: profileUser?.chatId })}
        mutualGroups={getMutualGroups(profileUser)}
        onOpenGroup={(group) => {
          setSelectedItem({
            type: "group",
            groupId: group.groupId,
            name: group.name,
            groupImageUrl: group.groupImageUrl,
          });

          setActiveTab(TABS.CHATS);
        }}
        myMediaPosts={getMediaPostsForUser(profileUser)}
        viewedUser={profileUser}
        currentUser={currentUser}
        avatarUrl={avatarUrl}
        myUserName={myUserName}
        myDisplayName={myDisplayName}
        users={users}
        mediaCommentsByPost={mediaCommentsByPost}
        mediaSocket={mediaSocket}
      />
    </>
  );
}